export const MenuItemHoverTime = 200;

export enum MenuClosureReasons {
	ClickOut,
	Cancelled,
	Executed,
}